<app-hero-landing [heroData]="heroDataService"></app-hero-landing>
<app-body-landing [landingData]="landingDataService"></app-body-landing>
